import Image from "next/image";

interface EvolutionArrowProps {
  cost: number;
}

const EvolutionArrow = ({ cost }: EvolutionArrowProps) => {
  return (
    <div className="xs:flex-row max-xs:flex-col flex flex-col items-center justify-center gap-2">
      {/* Note: Original CSS broke flex direction at < 500px. Tailwind 'xs' default is 480px usually but not standard. 
           I'll use specific arbitrary query or standard sm/md. 
           Origin: @media only screen and (width < 500px) { wrapper { flex-direction: column; } group { flex-direction: row; } arrow { rotate: 90deg; } }
           Default (Desktop): wrapper row, group col.
           So: flex max-[500px]:flex-col
       */}
      <div className="flex flex-col items-center justify-center gap-1 font-bold max-[500px]:flex-row">
        {cost}
        <Image src="/candy.svg" alt="Evolution Candy Icon" width={12} height={12} />
      </div>
      <Image
        className="flex h-[29px] w-[17px] max-[500px]:h-[17px] max-[500px]:w-[29px] max-[500px]:rotate-90"
        src="/arrowRight.svg"
        alt="Evolution Arrow Icon"
        width={17}
        height={29}
      />
    </div>
  );
};

export default EvolutionArrow;
